import React from "react";
import styles from "./attachments-modal.module.scss";
import Button from "../../components/ui-kit/button/button";
import DocumentDownload from "../../components/ui-kit/document-download/document-download";
import { getAttachmentDownload } from "../../services/api";
import { Attachment } from "../../interfaces/feature-info";
import CustomScrollbar from "../../components/ui-kit/scrollbar/scrollbar";
import { useTranslation } from "react-i18next";
import Modal from "../modal/modal";

interface Props {
  text: string;
  onClose: () => void;
  documents?: Attachment[];
}

const AttachmentsModal = ({ onClose, text, documents }: Props) => {
  const { t } = useTranslation();
  const handleClickDownloadButton = async (id: number, filename: string) => {
    try {
      const blob = await getAttachmentDownload(id, filename);

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <Modal onClose={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.plotNumber}>
          {t("attachments-modal.title", { text })}
        </h2>
        <div className={styles.atachmentsFound}>
          {t("attachments-modal.attachmentsLabel")}
          <span>
            {t("attachments-modal.foundCount", { count: documents?.length })}
          </span>
        </div>
        {documents &&
          documents.length > 0 &&
          (documents.length > 5 ? (
            <CustomScrollbar height={214}>
              <div
                className={`${styles.atachmentsList} ${styles.scrollAttachmentsList}`}
              >
                {documents.map((document, index) => (
                  <DocumentDownload
                    key={index}
                    filename={document.fileName}
                    onDownload={() =>
                      handleClickDownloadButton(document.id, document.fileName)
                    }
                    showDownloadButton={true}
                  />
                ))}
              </div>
            </CustomScrollbar>
          ) : (
            <div className={styles.atachmentsList}>
              {documents.map((document, index) => (
                <DocumentDownload
                  key={index}
                  filename={document.fileName}
                  onDownload={() =>
                    handleClickDownloadButton(document.id, document.fileName)
                  }
                  showDownloadButton={true}
                />
              ))}
            </div>
          ))}
        <Button
          className={styles.outlineCloseButton}
          type="outline"
          onClick={onClose}
        >
          {t("attachments-modal.close.button")}
        </Button>
      </div>
    </Modal>
  );
};

export default AttachmentsModal;
